import { Component, OnInit, TemplateRef, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { FilterOption, FilterOptionItem, AdvancedFilter } from '../objects/SummaryObject';
import { SummaryService } from '../services/summary.service';
import { ViewService } from '../services/view.service';
import { ConfirmationService } from '../services/confirmation.service';
import { CustomPopupService } from '../services/custom-popup.service';
import { Toast, BodyOutputType, ToasterService } from 'angular2-toaster';
import { Toaster } from '../objects/ToasterObject';
import { ToasterMessageService } from '../services/toaster-message.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { ActivatedRoute } from '@angular/router';
import { TokenManager } from '../Globals';
import { DatePipe } from '@angular/common';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { EnvService } from '../env.service';
import * as moment from 'moment';

@Component({
  selector: 'app-filteroption',
  templateUrl: './filteroption.component.html',
  styleUrls: ['./filteroption.component.css'],
  providers: [DatePipe]
})
export class FilteroptionComponent implements OnInit {
  
  @ViewChild('viewName') public viewNameInput: any;
  @ViewChild(ContextMenuComponent) public basicMenu: ContextMenuComponent;

  @Input() componentId:string;
  @Input() isCustomFilter: boolean = false;
  @Output() refreshSummary = new EventEmitter<boolean>();
  @Output() refreshView = new EventEmitter<boolean>();
  filterOptions:FilterOption[];
  modalRef: BsModalRef;
  selectedItem=[];
  isEmptyView: boolean = false;
  isLoading:boolean = false;
  hasFilters: boolean = false;
  isApplyingFilter: boolean = false;
  applied: boolean = false;
  currentInput: string;
  currentFilterField: string;
  isBusy:boolean = false;
  refreshValue: boolean = false;
  viewName: string;
  isRPF1: boolean = false;
  fromDate: any;
  toDate: any;
  Fromdatevalue:any;
  Todatevalue:any;
  fromdatevalue: string;
  Filterreport: string = "";

  constructor(private modalService: BsModalService, 
    private summaryService:SummaryService, 
    private viewService: ViewService, 
    private confirmationService: ConfirmationService, 
    private customPopupService:CustomPopupService,
    private toasterMessageService:ToasterMessageService,
    private tokenManager:TokenManager,
    private toasterService: ToasterService,
    private contextMenuService: ContextMenuService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private env: EnvService) { 
      this.Filterreport = this.env.Filterreport;
    }

  showFilterOptions(template: TemplateRef<any>):void{
    this.isBusy = true;
    this.applied = false;
    this.summaryService.getSummaryFilterOptions(this.componentId).subscribe(result=>{
      this.filterOptions = JSON.parse(result);
      if( this.Filterreport === "RPF"){
        const dateFields = ['CreatedSubmittedDateFrom', 'CreatedSubmittedDateTo'];

       this.filterOptions.sort((a, b) => {
         const aIndex = dateFields.indexOf(a.FilterField);
         const bIndex = dateFields.indexOf(b.FilterField);

         if (aIndex === -1 && bIndex === -1) return 0;
         if (aIndex === -1) return 1;
         if (bIndex === -1) return -1;

         return aIndex - bIndex; 
     });      
     }
      this.filterOptions.forEach(element => {
        if(element.FilterOptionItems){
          this.summaryService.CheckAdvancedSummaryFilter(this.componentId, element.FilterField).subscribe(result => {
            if (result){
              var advanceFilter:AdvancedFilter = JSON.parse(result);
              this.hasFilters = true;
              this.filterOptions.find(x => x.FilterField == element.FilterField).HasAdvancedFilter = true;
              this.filterOptions.find(x => x.FilterField == element.FilterField).AdvancedFilterValue = advanceFilter.FilterValue;
              this.filterOptions.find(x => x.FilterField == element.FilterField).AdvancedFilterType = advanceFilter.FilterType;
            }
          })
          
          if (element.FilterOptionItems.find(x=>x.IsChecked == true) != null){
            this.hasFilters = true;
            element.SelectedFilterItem = [];
            element.FilterOptionItems.filter(x => x.IsChecked == true).forEach(item => {
              element.SelectedFilterItem.push(item.ItemValue);
            });
          }
          else{
            element.SelectedFilterItem = null;
          }
        }
        element.IsDropdownOpen = false;
      });
      document.querySelector('footer').classList.add('hide');

      const config: ModalOptions = {
        keyboard: false,
        ignoreBackdropClick: true,
        class: 'modal-dialog-centered filter-modal'
      };

      if (this.modalService.getModalsCount() > 0){
        document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
      }
  
      this.modalService.onHide.subscribe((reason: string) => {
        if (this.modalService.getModalsCount() > 0){
          document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.add('show');
        }
      })

      
      this.modalRef = this.modalService.show(template, config);
      this.modalService.onHidden.subscribe((reason: string) => {
        document.querySelector('footer').classList.remove('hide');
        if (reason){
          if (reason == "esc"){
            this.changeFilter();
          }
        }
        this.currentFilterField = "";
      });
      this.isBusy = false;
    }, error => {
      this.isBusy = false;
    });
  }

  showFilterAsContextMenu(contextMenu:any = null, customFilter: any):void{
    this.isBusy = true;
    this.summaryService.getSummaryFilterOptions(this.componentId).subscribe(result=>{
      this.filterOptions = JSON.parse(result);
      this.filterOptions.forEach(element => {
        if(element.FilterOptionItems){
          this.summaryService.CheckAdvancedSummaryFilter(this.componentId, element.FilterField).subscribe(result => {
            if (result){
              var advanceFilter:AdvancedFilter = JSON.parse(result);
              this.hasFilters = true;
              this.filterOptions.find(x => x.FilterField == element.FilterField).HasAdvancedFilter = true;
              this.filterOptions.find(x => x.FilterField == element.FilterField).AdvancedFilterValue = advanceFilter.FilterValue;
              this.filterOptions.find(x => x.FilterField == element.FilterField).AdvancedFilterType = advanceFilter.FilterType;
            }
          })
          
          if (element.FilterOptionItems.find(x=>x.IsChecked == true) != null){
            this.hasFilters = true;
            element.SelectedFilterItem = [];
            element.FilterOptionItems.filter(x => x.IsChecked == true).forEach(item => {
              element.SelectedFilterItem.push(item.ItemValue);
            });
          }
          else{
            element.SelectedFilterItem = null;
          }
        }
        element.IsDropdownOpen = false;
      });

      this.contextMenuService.show.next({
        anchorElement: customFilter,
        contextMenu: this.basicMenu,
        event: contextMenu,
        item: ''
      });
     
      this.isBusy = false;
    }, error => {
      this.isBusy = false;
    });
  }

  changeFilter(){
    var checkedItemsOnly:FilterOption[] = [];

    this.filterOptions.forEach(filterOption =>{
      var filteredList:FilterOption = JSON.parse(JSON.stringify(filterOption));
      if(filteredList.FilterOptionItems){
        filteredList.FilterOptionItems = filteredList.FilterOptionItems.filter(x=> x.IsChecked);
        if(filteredList.FilterOptionItems.length > 0){
          checkedItemsOnly.push(filteredList);
        }
      }
    });

    this.summaryService.changeFilter(this.componentId, checkedItemsOnly).subscribe(result=>{
    });
  }

  getFilterOptions(filterField:string, $event)
  {
    document.querySelectorAll("body").item(0).style.position = "relative";
    if (this.currentFilterField != filterField){
      this.filterOptions.find(x => x.FilterField == filterField).IsLoading = true;
      this.currentFilterField = filterField;
      this.summaryService.getSummaryFilterOptionList(this.componentId, filterField).subscribe(result=>{
        var currentFilterItems:FilterOptionItem[] = [];
        currentFilterItems = JSON.parse(result);
        this.filterOptions.find(x => x.FilterField == filterField).IsLoading = false;
        currentFilterItems.forEach(item => {
          if (!item.ItemDisplay){
            item.ItemDisplay = "(Blanks)";
          }
        });

        if (!$event.target.classList.contains("ng-value-icon")){
          this.filterOptions.forEach(option => {
            option.IsDropdownOpen = false;
          })
          this.filterOptions.find(x => x.FilterField == filterField).IsDropdownOpen = true;
          this.filterOptions.find(x => x.FilterField == filterField).FilterOptionItems = currentFilterItems;
        }
      });
    }
    else{
      if (!$event.target.classList.contains("ng-value-icon")){
        this.filterOptions.find(x => x.FilterField == filterField).IsDropdownOpen = !this.filterOptions.find(x => x.FilterField == filterField).IsDropdownOpen;
      }
      else{
        this.filterOptions.forEach(option => {
          option.IsDropdownOpen = false;
        })
        this.filterOptions.find(x => x.FilterField == filterField).IsDropdownOpen = false;
      }
    }

    $event.stopPropagation();
    $event.preventDefault();
  }

  onCloseFilterOptions(){
    document.querySelectorAll("body").item(0).style.position = "initial";
  }

  applyFilterChanges(){
    var checkedItemsOnly:FilterOption[] = [];
    this.filterOptions.forEach(filterOption =>{
      var filteredList:FilterOption = JSON.parse(JSON.stringify(filterOption));
      if(filteredList.FilterOptionItems){
        filteredList.FilterOptionItems = filteredList.FilterOptionItems.filter(x=> x.IsChecked);
        if(filteredList.FilterOptionItems.length > 0){
          checkedItemsOnly.push(filteredList);
        }
      }
    });

    this.isApplyingFilter = true;
    this.summaryService.changeFilter(this.componentId, checkedItemsOnly).subscribe(result=>{
      if(result == "1"){
        this.summaryService.applyFilters(this.componentId).subscribe(applied=>{
          if(applied == "1"){
            if (this.modalRef) {
              this.applied = true;
              this.modalRef.hide();
            }
            else{
              this.contextMenuService.closeAllContextMenus(null);
            }
            this.refreshSummary.emit(true);
          }
          setTimeout(()=> {
            this.isApplyingFilter = false;
          }, 1000)
        })
      }
    }, error =>  {
      this.isApplyingFilter = false;
    })
  }

  applyFilterChanges1() {

    let apiFilters: FilterOption[] = [];
  
    const fromDateStr = this.fromDate ? this.toLocalISOString(this.fromDate) : null;
  const toDateStr = this.toDate ? this.toLocalISOString(this.toDate) : null;
  
  // Clone only checked dropdown filters
    this.filterOptions.forEach(option => {
      const cloned = JSON.parse(JSON.stringify(option));
  
      if (cloned.FilterOptionItems) {
        cloned.FilterOptionItems = cloned.FilterOptionItems.filter(x => x.IsChecked);
      }
  
      if (
        (cloned.FilterOptionItems && cloned.FilterOptionItems.length) ||
        (cloned.SelectedFilterItem && cloned.SelectedFilterItem.length)
      ) {
        apiFilters.push(cloned);
      }
    });
  
    apiFilters = apiFilters.filter(f => f.FilterField !== 'CreatedSubmittedDateFrom');
  
    let dateFilter = null;

    if (this.filterOptions) {
      dateFilter = this.filterOptions.find(function(f) {
        return f.FilterField === 'CreatedSubmittedDateFrom';
      });
    }
  
    if (dateFilter) {
      
    if (fromDateStr || toDateStr) {
      apiFilters.push({
        FilterField: 'CreatedSubmittedDateFrom',
        FilterOptionType: 'DATE',
        FilterOptionDisplay: 'CreatedSubmittedDate',
        FilterType: 'BETWEEN',
        FilterOptionItems: [{IsChecked: true, ItemValue:fromDateStr, ItemDisplay:fromDateStr },
          {IsChecked: true, ItemValue:toDateStr, ItemDisplay:toDateStr }],
        SelectedFilterItem: [fromDateStr, toDateStr]
      } as any);
    }
  
     }
     
    this.isApplyingFilter = true;
    this.summaryService.changeFilter(this.componentId, apiFilters).subscribe(result => {
      if (result == "1") {
         this.summaryService.applyFilters(this.componentId).subscribe(applied => {
          if (applied == "1") {
            if (this.modalRef) {
              this.applied = true;
              this.modalRef.hide();
            }
            this.refreshSummary.emit(true);
          }
          setTimeout(() => {
            this.isApplyingFilter = false;
          }, 1000)
        })
        }
      }, error => {
      this.isApplyingFilter = false;
    })
  }

  checkItem(filterField:string, event, filter: NgSelectComponent){
    if (Array.isArray(event)){
      if (event.length > 0){
        this.filterOptions.find(x=> x.FilterField == filterField).FilterOptionItems.forEach(item => {
          item.IsChecked = false;
          if (event.filter(x => x.ItemValue == item.ItemValue).length > 0){
            item.IsChecked = true;
          }
        });
      }
      else {
        this.filterOptions.find(x=> x.FilterField == filterField).FilterOptionItems.forEach(element => {
          if (element.IsChecked){
            element.IsChecked = false
          }
        });
      }

      this.hasFilters = false;
      this.filterOptions.forEach(option => {
        if(option.HasAdvancedFilter){
          this.hasFilters = true;
              return;
        }
        if (option.SelectedFilterItem){
          if (option.SelectedFilterItem.length > 0){
            this.hasFilters = true;
              return;
          }
        }
      });
      
      // filter.filter(this.currentInput);
    }
  }

  mouseEnter($event){
    if (document.querySelectorAll('.ng-option').item(0)){
      document.querySelectorAll('.ng-option').item(0).classList.remove("ng-option-marked");
    }
  }

  log(event){
    console.log(event);
  }

  mouseLeave($event){
    if ($event.toElement.className == "ng-dropdown-panel-items scroll-host"){
      document.querySelectorAll('.ng-option').item(0).classList.add("ng-option-marked");
    }
  }

  input(filter: NgSelectComponent, $event: any){
    this.currentInput = $event.target.value;
    filter.filter($event.target.value);
  }

  openCustomFilter(option: FilterOption){
    this.customPopupService.confirm("Custom Filter", option, option.AdvancedFilterValue, ["OK"], option.AdvancedFilterType).subscribe((respond) => {
      if (respond.answer == 'OK' && respond.respondObject) {

        var param:AdvancedFilter[] = new Array();
        var filter:AdvancedFilter = new AdvancedFilter();
        filter.FilterField = option.FilterField;
        filter.FilterType = respond.respondObject["filter"];
        filter.FilterValue = respond.respondObject["value"];
        param.push(filter);

        this.summaryService.AddAdvancedSummaryFilter(this.componentId, param).subscribe(result => {
          if (result == "1"){
            this.popToast("Info", "Custom filter added for " + option.FilterOptionDisplay, "info");
            this.hasFilters = true;
            this.filterOptions.find(x => x.FilterField == option.FilterField).HasAdvancedFilter = true;
            this.filterOptions.find(x => x.FilterField == option.FilterField).AdvancedFilterValue = filter.FilterValue;
            this.filterOptions.find(x => x.FilterField == option.FilterField).AdvancedFilterType = filter.FilterType;
          }
        })
      }
      else if (respond.answer == 'CLEAR' && respond.respondObject) {
        this.filterOptions.find(x => x.FilterField == option.FilterField).HasAdvancedFilter = false;
        this.filterOptions.find(x => x.FilterField == option.FilterField).AdvancedFilterValue = "";
        this.filterOptions.find(x => x.FilterField == option.FilterField).AdvancedFilterType = "";
        this.clearFilter(option);
      }
    });
  }

  clearFilter(option: FilterOption){
    this.summaryService.RemoveAdvancedSummaryFilter(this.componentId, option.FilterField).subscribe(result => {
      if (result == "1"){
        this.popToast("Info", "Custom filter removed for " + option.FilterOptionDisplay, "info");
        this.filterOptions.find(x => x.FilterField == option.FilterField).HasAdvancedFilter = false;
        this.filterOptions.find(x => x.FilterField == option.FilterField).AdvancedFilterValue = "";

        this.hasFilters = false;
        this.filterOptions.forEach(option => {
          if(option.HasAdvancedFilter){
            this.hasFilters = true;
            return;
          }
          if (option.FilterOptionItems){
            if (option.FilterOptionItems.filter(x => x.IsChecked).length > 0){
              this.hasFilters = true;
              return;
            }
          }
        });
      }
    })
  }

  clearAllFilters(){
    this.filterOptions.forEach(element => {
      element.SelectedFilterItem = [];
      element.AdvancedFilterType = "";
      element.AdvancedFilterValue = "";
      if (element.FilterOptionItems){
        element.FilterOptionItems.forEach(item => {
          item.IsChecked = false;
        });
      }
    });

    this.fromDate = null;
    this.toDate = null;

    this.summaryService.ClearSummaryFilter(this.componentId).subscribe(result => {
      if (result == "1"){
        this.summaryService.ClearAdvancedSummaryFilter(this.componentId).subscribe(result => {
          if (result == "1"){
            this.hasFilters = false;
            this.popToast("Info", "All filters has been cleared" , "info");
            this.filterOptions.filter(x => x.HasAdvancedFilter).forEach(element => {
              element.HasAdvancedFilter = false;
            })
          }
        })
      }
    });
  }

  popToast(title: string, body: string, type:string) {
    var toast: Toast = {
      type: type,
      title: title,
      body: body,
      showCloseButton: true,
      bodyOutputType: BodyOutputType.TrustedHtml,
      onShowCallback: (toast) => 
      {
        var toaster = new Toaster();
        toaster.id = toast.toastId;
        toaster.timestamp = Date.now();
        toaster.title = toast.title;
        toaster.content = toast.body;
        this.toasterMessageService.pushToaster(toaster);
      } 
    };
    this.toasterService.pop(toast);
  }

  selectAll($event, ctx:any){
    if ($event.currentTarget.checked){
      if (ctx.itemsList.filteredItems.length > 0){
        ctx.itemsList.filteredItems.forEach(item => ctx.select(item));
      }
      else {
        ctx.itemsList.items.forEach(item => ctx.select(item));
      }
      ctx.detectChanges();
    }
    else {
      if (ctx.itemsList.filteredItems.length > 0){
        ctx.itemsList.filteredItems.forEach(item => ctx.unselect(item));
      }
      else {
        ctx.itemsList.items.forEach(item => ctx.unselect(item));
      }
      ctx.detectChanges();
    }
  }

  createNewView(parentId: string = '00000000-0000-0000-0000-000000000000'){
    var viewName = this.viewName;
    var checkedItemsOnly:FilterOption[] = [];

    this.filterOptions.forEach(filterOption =>{
      var filteredList:FilterOption = JSON.parse(JSON.stringify(filterOption));
      if(filteredList.FilterOptionItems){
        filteredList.FilterOptionItems = filteredList.FilterOptionItems.filter(x=> x.IsChecked);
        if(filteredList.FilterOptionItems.length > 0){
          checkedItemsOnly.push(filteredList);
        }
      }
    });

    if (viewName){
      this.isApplyingFilter = true;
      this.summaryService.changeFilter(this.componentId, checkedItemsOnly).subscribe(result=>{
        if(result == "1"){
          this.summaryService.applyFilters(this.componentId).subscribe(applied=>{
            if(applied == "1"){
              this.viewService.createNewView(this.componentId, viewName, parentId).subscribe(result => {
                if(result == "1"){
                  this.hide();
                }
                this.isApplyingFilter = false;
                this.viewService.setRefreshView(true);
              }, error => {
                this.isApplyingFilter = false;
              });
            }
            else{
              this.isApplyingFilter = false;
            }
          }, error => {
            this.isApplyingFilter = false;
          })
        }
        else{
          this.isApplyingFilter = false;
        }
      }, error => {
        this.isApplyingFilter = false;
      })
    }
    else{
      this.isEmptyView = true;
    }
  }

  onBlur(filterField: string, $event){
    if ($event.relatedTarget){
      if ($event.relatedTarget.className == "checkbox-input" || $event.relatedTarget.className == "custom-input-search"){
        
      }
      else {
        this.filterOptions.find(x => x.FilterField == filterField).IsDropdownOpen = false;
      }
    }
  }

  onBlurInput($event){
    if ($event.relatedTarget){
      if ($event.relatedTarget.className == "modal fade show"){
        this.filterOptions.forEach(option => {
          option.IsDropdownOpen = false;
        })
      }
    }
  }

  onKeyUp(value){
    this.isEmptyView = false;
    this.viewName = value;
  }

  hide() {
    this.changeFilter();
    this.modalRef.hide();
  }

  public onContextMenu($event, customFilter: any): void {
    if($event.button == 0){
      this.showFilterAsContextMenu($event, customFilter);
    }
    $event.preventDefault();
    $event.stopPropagation();
  }

  ngOnInit() {

    const currentRoute = this.tokenManager.retrieve("BRNCurrentRoute");

  if (currentRoute) {
    const routeParts = currentRoute.split('/');
    this.isRPF1 = routeParts[3] === this.Filterreport;
  }
  if(this.isRPF1)
  {
   this.fromdatevalue = this.formatDates(new Date(new Date().setMonth(new Date().getMonth() - this.env.ReportFromDateMonth)));
   this.Fromdatevalue =  this.fromdatevalue;
   this.Todatevalue= this.formatDates(this.env.ReportToDate);

  if (!this.fromDate && this.env.ReportFromDateMonth) {
    this.fromDate = new Date(this.Fromdatevalue);
  }

  if (!this.toDate && this.env.ReportToDate) {
    this.toDate = new Date(this.Todatevalue);
  } 
  }
  }

  formatDate(date: Date): string {
    if (!date) return '';
    return this.datePipe.transform(date, 'ddMMMYYYY') || '';
}

customDateParser = (value: string): Date | null => {
  if (!value) return null;
  const regex = /^(\d{2})([A-Za-z]{3})(\d{4})$/;
  const match = value.match(regex);
  if (match) {
    const date = new Date(`${match[2]} ${match[1]}, ${match[3]}`);
    return isNaN(date.getTime()) ? null : date;
  }
  return null;
};

onDateChange(value: Date | string | moment.Moment, type: 'FromDate' | 'ToDate') {
if (!value) return;

let date: Date;

if (value instanceof Date) {
  date = value;
} else if (moment.isMoment(value)) {
  // Convert Moment to Date
  date = value.toDate();
} else if (typeof value === 'string') {
  // Parse manual string input (yyyy-mm-dd)
  const parts = value.split('-').map(Number);
  if (parts.length === 3) {
    date = new Date(parts[0], parts[1] - 1, parts[2]);
  } else {
    console.warn('Invalid date string:', value);
    return;
  }
} else {
  console.warn('Unknown date value:', value);
  return;
}

// Save to appropriate field
if (type === 'FromDate') this.fromDate = date;
if (type === 'ToDate') this.toDate = date;

this.hasFilters = true;
}

  formatDates(date) {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

toLocalISOString(date: Date) {
const pad = (n: number) => n.toString().padStart(2, '0');
return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T00:00:00.000`;
}

}
